// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activeRow,.activeRowRiOutBord{background-color:#fff9c4}", ""]);
// Exports
module.exports = exports;
